import React from "react";

const logos = [
  { name: "Gillco", src: "https://customer-assets.emergentagent.com/job_aqua-automation-6/artifacts/0p3wphcj_IMG_4244.png" },
  { name: "Himachal Pradesh Jal Shakti Vibhag", src: "https://customer-assets.emergentagent.com/job_aqua-automation-6/artifacts/djmq15gn_IMG_4245.webp" },
  { name: "IISER Mohali", src: "https://customer-assets.emergentagent.com/job_aqua-automation-6/artifacts/yjq80zts_IMG_4246.png" },
  { name: "CPWD", src: "https://customer-assets.emergentagent.com/job_aqua-automation-6/artifacts/ttescb98_IMG_4247.jpeg" },
  { name: "PGIMER Chandigarh", src: "https://customer-assets.emergentagent.com/job_aqua-automation-6/artifacts/woavec77_IMG_4432.png" },
  { name: "Radisson Blu", src: "https://www.aquabrim.com/assets/client/1280px-Radisson_Blu_logo.svg.png" },
  { name: "BHEL", src: "https://www.aquabrim.com/assets/client/Bharat_Heavy_Electricals_Limited-Logo.wine.png" },
  { name: "BPCL", src: "https://www.aquabrim.com/assets/client/Bharat_Petroleum_logo.svg.png" },
  { name: "Coca-Cola", src: "https://www.aquabrim.com/assets/client/Coca-Cola_logo.svg.png" },
  { name: "EIL", src: "https://www.aquabrim.com/assets/client/EIL%20logo.png" },
  { name: "Indian Oil", src: "https://www.aquabrim.com/assets/client/Indian-Oil-Logo-768x483.png" },
  { name: "Indian Railways", src: "https://www.aquabrim.com/assets/client/Indian_Railway_Logo_2.png" },
  { name: "Unilever", src: "https://www.aquabrim.com/assets/client/Unilever.svg.png" },
  { name: "Emaar", src: "https://www.aquabrim.com/assets/client/Emaar-Properties-Logo-1.jpg.jpeg" },
  { name: "Max Healthcare", src: "https://www.aquabrim.com/assets/client/max%20healthcar.png" },
  { name: "Bhutani Infra", src: "https://www.aquabrim.com/assets/client/bhutani%20infra%20logo.png" },
  { name: "Hyatt Regency", src: "https://www.aquabrim.com/assets/client/hyatt%20regency.jpeg" },
  { name: "PWD", src: "https://www.aquabrim.com/assets/client/pwd.jpeg" },
  { name: "M3M", src: "https://www.aquabrim.com/assets/client/M3M.webp" },
];

export default function Clients() {
  const row = [...logos, ...logos];
  return (
    <section className="border-b border-zinc-200 bg-white">
      <div className="px-6 md:px-12 lg:px-24 py-20">
        <div className="max-w-2xl mb-10">
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#002FA7] mb-4">
            /// They trust Aquamatic
          </div>
          <h3 className="text-3xl sm:text-4xl font-semibold tracking-tight leading-tight">
            Installed for the brands that can&apos;t afford water downtime.
          </h3>
        </div>
      </div>
      <div className="overflow-hidden border-y border-zinc-200 bg-[#F4F4F5]">
        <div className="marquee-track py-8">
          {row.map((l, i) => (
            <div
              key={`${l.name}-${i}`}
              className="flex items-center justify-center px-10 shrink-0"
              style={{ minWidth: 200 }}
            >
              <img
                src={l.src}
                alt={l.name}
                loading="lazy"
                className="h-10 md:h-12 w-auto object-contain grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
